<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="crtf"><a class="page" id="page.iv"></a>© 1996 Wm. B. Eerdmans Publishing Co.</p>
<p class="crt">2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /</p>
<p class="crt">P.O. Box 163, Cambridge CB3 9PU U.K.</p>
<p class="crt">All rights reserved</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Moo, Douglas J.</p>
<p class="cip">The Epistle to the Romans / Douglas J. Moo</p>
<p class="cip">p. cm.</p>
<p class="cip">— (The new international commentary on the New Testament)</p>
<p class="cip">Includes <a class="xref" href="#/eernicnt66ro0008#BIBLIO">bibliographical references</a> and <span class="xref" href="#/eernicnt66ro0018#INDEX1" title="Link target outside of Sample">indexes.</span></p>
<p class="cip">eISBN 978-1-4674-2269-7</p>
<p class="cip">ISBN 0-8028-2317-3</p>
<p class="cip">1. Bible. N.T. Romans—Commentaries. I. Title. II. Series.</p>
<p class="cip">BS2665.3.M55 1966</p>
<p class="cip">227′.107—dc20          96-26077</p>
<p class="crtf"><a class="url" href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eernicnt66ro0003.vue?00e5af24